import React from 'react';
import dayjs from '../../../helpers/dates';
import View from './View';
import Text from './Text';
import { Theme } from '../../../theme';

interface HeaderProps {
  title?: string;
  startDate?: string;
  endDate?: string;
  noDate?: boolean;
}

const Header = ({ title, startDate, endDate, noDate }: HeaderProps) => {
  return (
    <View
      fixed
      flexDirection="row"
      alignItems="row"
      justifyContent="space-between"
      pb="10pt"
    >
      <View flexDirection="row" alignItems="center">
        <Text>{title}</Text>
      </View>
      <View alignItems="flex-end">
        {!noDate && (
          <View alignSelf="flex-start" justifySelf="flex-end">
            <Text color={Theme.colors.grey} fontSize="8pt">
              Date Range: {startDate} - {endDate}
            </Text>
          </View>
        )}
        <Text color={Theme.colors.grey} fontSize="8pt">
          Created: {dayjs().format('YYYY/MM/DD hh:mma')}
        </Text>
      </View>
    </View>
  );
};

export default Header;
